/**
HOW THIS FILE WORKS AND WHAT IT DOES
-----------------------------------

The Namespace implementation consists in creating a literal object to map the views and call them once a pair of rails
controller/action matches them.

For instance, let's assume if you have the following view registered:

    // stores/new.js
    namespace('IO.Views.Stores', (exports) => {
        exports.New = () => console.log('Stores/new has just been called!')
    })

This view will be called when the user nagivates to /:current_customer/stores/new.

You can also reference a Namespace view by calling it directly:

    IO.Views.Stores.New()

However, namespace views must be manually imported in the /assets/javascripts/app/namespace.js and you can only call
namespace view if the view file you are calling has been imported before in than your file in  namespace.js.

Limitations of the Namespace approach are:

- Developers need to care about the loading order of the files
- You cannot reuse a file for more than one namespace
*/

(function () {
  window.namespace = function (ns, payload) {
    var currentPart, parent, parts;

    payload = payload || {};
    parts = ns.split('.');
    parent = window;
    currentPart = parts.shift();

    while (currentPart) {
      if (parts.length !== 0) {
        parent[currentPart] = parent[currentPart] || {};
      } else {
        parent[currentPart] = parent[currentPart] || payload;
      }

      parent = parent[currentPart];
      currentPart = parts.shift();
    }
    return payload(parent);
  };

  window.getModule = function (ns) {
    var parts = ns.split('.'),
      parent = window,
      currentPart = parts.shift();

    while (currentPart) {
      parent = parent[currentPart];

      if (!parent) {
        break;
      }
      currentPart = parts.shift();
    }

    return parent;
  };
}).call(this);
